import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "flex field-sizing-content min-h-16 w-full resize-none rounded-sm border border-line-2 bg-background px-2.5 py-1.5 text-[13px] leading-5 text-foreground transition-[border-color] duration-[120ms] outline-none placeholder:text-fg-3 focus-visible:border-focus focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-focus disabled:cursor-not-allowed disabled:opacity-55 aria-invalid:border-danger",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
